import { type DepositAccount } from '@fruitful/types';

import type { User } from '../../user/types/User';
import {
    AccountType,
    type BankAccountDisplayDetail,
    RelationshipStatus,
    SyncteraAccountStatus,
} from '../types/BankAccount';

export const isAccountValidAsIncomeSplitSource = (
    user: User,
    account: BankAccountDisplayDetail,
): boolean => {
    if (account.accountStatus !== SyncteraAccountStatus.ACTIVE_OR_DISBURSED)
        return false;

    const isJointMembership = !!user.partnerMember;

    if (isJointMembership) {
        // check if account has a joint user that has accepted the invite, and the account is not a charge secured account
        return (
            account.jointUser != null &&
            account.jointUserRelationshipStatus === RelationshipStatus.ACTIVE &&
            (account.primaryUser.id === user.id ||
                account.jointUser?.id === user.id) &&
            account.accountType !== AccountType.CHARGE_SECURED
        );
    } else {
        // check if account is not charge secured
        return account.accountType !== AccountType.CHARGE_SECURED;
    }
};

// Eligible if solo membership OR the account is joint
export const selectedDepositoryAccountEligibleForSplit = (
    user: User,
    bankAccountDetails: BankAccountDisplayDetail[],
    selectedToAccount?: DepositAccount | null,
) => {
    return (
        user.partnerMember == null ||
        bankAccountDetails.find(
            (account) => account.syncteraAccountId === selectedToAccount?.id,
        )?.jointUser != null
    );
};
